import { getDirectDebitMandateTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { useClientStore } from '@/stores/client.js'

export async function buildDirectDebitMandate(taskId) {
 

  const client = useClientStore();

    if(client.clientType == 'IntermediaryClient') return null;

    // Call direct debit mandate API to get the status of the direct debit mandate process
    var response = await getDirectDebitMandateTask(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
        console.error('Error fetching direct debit mandate task');
        return null;
    }

    const task = response.data;

    const card = {
    id: task.taskId,
    title: task.taskName,
    subtitle: 'Complete your Direct Debit Mandate',
    progress: 0,
    subProgressMessage: '',
    status: task.taskStatus,
    route: '/tasks/direct-debit-mandate/' + task.taskId, 
    createdDate: new Date(task.createdDate)
  }
    
  return card 
}

